import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faCalendar, faChartLine, faChartSimple, faCreditCard, faGear, faPercentage, faUsd, faCalculator, faReceipt, faAngleUp, faBullseye, faCircleNotch, faArrowDown, faSackDollar, faClock, faAngleDown, faBuilding, faShield } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Pie1 from "../components/chart/Pie1";
import { Link } from 'react-router-dom';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import Upgrade401kModal from "../components/Upgrade401kModal";

function Manager() {
  const { user } = useUser();
  //CLEAR LOCAL Storage
  localStorage.clear();
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [totalSavings, setTotalSavings] = useState(0);  
  const [savingshistory, setSavingsHistory] = useState([]);
  const [allSavings, setAllSavings] = useState([]);
  const [enrollment, setEnrollment] = useState([]);
  const [crypto, setCrypto] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsavings: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedSavings = data.savings.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
            amountUSD = asset.price * tx.amount;
          }else{
            logo = `/uploads/usd.svg`;
            symbol = "USD";
            amountUSD = tx.amount;
          }
          return {
            ...tx,
            logo,
            symbol,
            amountUSD
          };
        });
        const updatedSavings1 = data.all.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
            amountUSD = asset.price * tx.amount;
          }else{
            logo = `/uploads/usd.svg`;
            symbol = "USD";
            amountUSD = tx.amount;
          }
          return {
            ...tx,
            logo,
            symbol,
            amountUSD
          };
        });
        setAllSavings(updatedSavings1);
        setSavingsHistory(updatedSavings);
        const amounts = updatedSavings.map(item => parseFloat(item.amountUSD) || 0);
        const total = amounts.reduce((sum, n) => sum + n, 0);
        setTotalSavings(total);
      }
    })
    .catch(err => {
    })
  }, [user, crypto]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchEnrollment: true })
    })
    .then(response => response.json())
    .then(data => {
      console.log(user.email)
      if (data.status === "success") {
        setEnrollment(data.enrollment)
      }
    })
    .catch(err => {
    })
  }, [user, crypto]);

  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const [change, setChange] = useState(0);
  const [contribution_rate, setContribution_rate] = useState(0);
  useEffect(() => {
    const randomFactor = Math.random() * 0.2 - 0.1;
    const previousBalance = Number(user?.savings) / (1 + randomFactor);
    const change =  Number(user?.savings) > 0 ? ((Number(user?.savings) - previousBalance) / previousBalance) * 100 : 0;
    setChange(change);
  }, [user])
  useEffect(() => {
    let rate = 1;
    if(user?.frequency == "monthly"){
      rate = 1;
    }else if(user?.frequency == "bi-weekly" || user?.frequency == "semi-monthly"){
      rate = 0.5;
    }
    setContribution_rate(rate);
  }, [user])

  function formatDate(dateString) {
    const date = new Date(dateString.replace(" ", "T"));
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', '');
  }

  function getNextContributionDate(lastDateString, frequency) {
    const lastDate = new Date(lastDateString);
    const nextDate = new Date(lastDate);
    switch (frequency?.toLowerCase()) {
      case 'bi-weekly':
        nextDate.setDate(lastDate.getDate() + 14);
        break;
      case 'semi-monthly':
        const day = lastDate.getDate();
        if (day < 15) {
          nextDate.setDate(15);
        } else {
          nextDate.setMonth(lastDate.getMonth() + 1);
          nextDate.setDate(1);
        }
        break;
      case 'monthly':
        nextDate.setMonth(lastDate.getMonth() + 1);
        break;
      default:
        return "Invalid frequency";
    }
    return nextDate.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).replace(',', '');
  }
  const [mutualfunds, setMutualfunds] = useState([]);
  const [etfs, setEtfs] = useState([]);
  const [allFunds, setAllFunds] = useState([]);
  const [stockDetails, setStockDetails] = useState([]);
  const [bondsDetails, setBondsDetails] = useState([]);
  useEffect(() => {
    fetch(`/uploads/investment/etfs.txt`)
    .then((res) => res.json())
    .then((data) => {
    var investment = data;
      setEtfs(investment);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/uploads/investment/mutualfunds.txt`)
    .then((res) => res.json())
    .then((data) => {
    var investment = data;
      setMutualfunds(investment);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!etfs.length && !mutualfunds.length) return;
    const merged = [...etfs, ...mutualfunds];
    for (let i = merged.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [merged[i], merged[j]] = [merged[j], merged[i]];
    }
    setAllFunds(merged);
  }, [etfs, mutualfunds]);
  useEffect(() => {
    if (!enrollment && !allFunds.length) return;
    const details = allFunds.find(asset => asset.symbol === enrollment?.stocks_investment);
    if (details) {
      const rating = Math.floor(Math.random() * 3) + 3;
      const updatedDetails = { ...details, rating };
      setStockDetails(updatedDetails);
    }
    //fetch bonds details
    const details1 = allFunds.find(asset => asset.symbol === enrollment?.bond_investment);
    if (details1) {
      const rating1 = Math.floor(Math.random() * 3) + 3;
      const updatedDetails1 = { ...details1, rating1 };
      setBondsDetails(updatedDetails1);
    }
  }, [allFunds, enrollment]);

  if (!enrollment || typeof enrollment !== 'object' || Object.keys(enrollment).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Upgrade401kModal UserDetails={user} enrollment={enrollment} />
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="401k Portfolio" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="401k Portfolio" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="mb-5">
            <h2 className="mt-3 mb-0" style={{fontWeight:'900'}}>401k Manager</h2>
            <p className="mb-0" style={{fontSize: '14px'}}>Overview of your 401k retirement account</p>
            <div className="row">
              <div className="col-lg-3 col-md-6 g-4">
                <div className="mycard p-3 position-relative" style={{border:'1px solid #a9a9a90f'}}>
                    <FontAwesomeIcon icon={faUsd} className="position-absolute text-success" style={{top:'20px', right:'20px',fontSize: '20px'}} />
                    <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Total Balance</p>
                    <h3 className="mb-0" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.savings * rate)}</h3>
                    <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}><span className={`${change > 0 ? 'text-success' : 'text-danger'}`}><FontAwesomeIcon icon={faArrowUp} style={{fontSize: '10px'}} className={`${change > 0 ? 'text-success' : 'text-danger'} me-1`} /> {change.toFixed(1)}%</span> vs last quarter</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 g-4">
                <div className="mycard p-3 position-relative" style={{border:'1px solid #a9a9a90f'}}>
                  <FontAwesomeIcon icon={faChartLine} className="position-absolute text-info" style={{top:'20px', right:'20px',fontSize: '20px'}} />
                  <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Total Contributions</p>
                  <h3 className="mb-0" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(totalSavings * rate)}</h3>
                  <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}><span className="text-info"><FontAwesomeIcon icon={faArrowUp} style={{fontSize: '10px'}} className="text-info me-1" /> {getCurrencySymbol(user?.currency)}{savingshistory.length > 0 ? formatCurrency(savingshistory['0'].amountUSD * rate) : 0}/mo</span> current contribution</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 g-4">
                <div className="mycard p-3 position-relative" style={{border:'1px solid #a9a9a90f'}}>
                    <FontAwesomeIcon icon={faPercentage} className="position-absolute text-primary" style={{top:'20px', right:'20px',fontSize: '20px'}} />
                    <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Employer Match</p>
                    <h3 className="mb-0" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.employee_match * rate)}</h3>
                    <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}><span className="text-primary"><FontAwesomeIcon icon={faArrowUp} style={{fontSize: '10px'}} className="text-primary me-1" /> 6.0%</span> match rate</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 g-4">
                <div className="mycard p-3 position-relative" style={{border:'1px solid #a9a9a90f'}}>
                    <FontAwesomeIcon icon={faCalendar} className="position-absolute text-warning" style={{top:'20px', right:'20px',fontSize: '20px'}} />
                    <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Vested Amount</p>
                    <h3 className="mb-0" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.vested_savings * rate)}</h3>
                    <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}><span className="text-warning"><FontAwesomeIcon icon={faArrowUp} style={{fontSize: '10px'}} className="text-warning me-1" /> {formatCurrency((user?.vested_savings/user?.savings) * 100)}%</span> vested</p>
                </div>
              </div>
              <div className="col-xxl-3 col-12 g-4">
                <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <Link to="/deposit" state={{route : '401k'}} className="rounded-3 text-center fw-semibold noLink" style={{border:'2px solid #ff6b35',cursor:'pointer',fontSize:'14px', width:'55%',paddingTop:'12px',paddingBottom:'12px'}}><FontAwesomeIcon icon={faSackDollar} style={{fontSize: '12px'}} className="me-1" /> Make Contribution</Link>
                      <Link to="/rwithdraw" state={{route : '401k'}} className="myBtn px-0 text-center fw-semibold noLink" style={{border:'2px solid #ff6b35',fontSize:'14px', width:'40%',paddingTop:'12px',paddingBottom:'12px'}}>Withdraw</Link>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faCreditCard} className="text-info" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Contributions</h5>
                        </div>
                        <Link to="/contributions" className="px-3 py-2 rounded-2 d-flex align-items-center justify-content-center noLink" style={{border:'1px solid #a9a9a90f'}}>
                            <FontAwesomeIcon icon={faGear} style={{fontSize: '14px'}} /> 
                            <p className="mb-0 fw-semibold ms-2" style={{fontSize:'14px'}}>Adjust</p>
                        </Link>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mt-4">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Your contribution</p>
                        <div className="text-end">
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency((contribution_rate * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100))}</p>
                            <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{formatCurrency(user?.savings_rate)}% of salary</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mt-3">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Employer match</p>
                        <div className="text-end">
                            <p className="mb-0 fw-semibold text-success" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(((contribution_rate * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100)) * (6/100))}</p>
                            <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>6.0% match</p>
                        </div>
                    </div>
                    <hr style={{opacity:'0.06'}}/>
                    <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0" style={{fontSize:'14px'}}>Total monthly</p>
                        <h4 className="mb-0 text-prime" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(((1 * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100)) + (((1 * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100)) * (6/100)))}</h4>
                    </div>
                    <div className="d-flex align-items-center justify-content-between myBtn mt-3 py-3">
                        <p className="mb-0" style={{fontSize:'14px'}}>Next contribution</p>
                        <p className="mb-0 fw-semibold">{enrollment.effective_date == "true" && savingshistory.length == 0 ? formatDate(user?.regdate) : getNextContributionDate(savingshistory.length > 0 ? savingshistory['0'].date : formatDate(user?.regdate) ,user?.frequency)}</p>
                    </div>
                </div>
              </div>
              <div className="col-xxl-3 col-12 g-4">
                <div className="mycard p-3 d-flex align-items-center justify-content-between" style={{border:'1px solid #a9a9a90f'}}>
                  <div>
                    <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Current Plan</p>
                    <h3 className="mb-0" style={{fontWeight:'900'}}>{enrollment?.plan}</h3>
                  </div>
                  <Link to="/upgradeplan" state={{route : '401k'}} className="py-2 px-3 rounded-3 text-center fw-semibold noLink" style={{border:'2px solid #ff6b35',cursor:'pointer',fontSize:'14px'}}>Upgrade Plan</Link>
                </div>
                <div className="mycard p-3 mt-2" style={{border:'1px solid #a9a9a90f'}}>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faCalculator} className="text-primary" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Retirement Outlook</h5>
                        </div>
                        <Link to="/contributions" className="px-3 py-2 rounded-2 d-flex align-items-center justify-content-center noLink" style={{border:'1px solid #a9a9a90f'}}>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Plan</p>
                        </Link>
                    </div>
                    <h3 className="mb-0 text-center" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(((((contribution_rate * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100)) + (((contribution_rate * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100)) * (6/100))) * 12) * (65 - Number(enrollment.start_age)))}</h3>
                    <p className="text-secondary mb-0 text-center" style={{fontSize:'14px'}}>Projected balance at 65</p>
                    <div className="d-flex align-items-center justify-content-between myBtn my-3 py-2 px-2">
                        <p className="mb-0" style={{fontSize:'14px'}}>Monthly income</p>
                        <div className="text-end">
                            <h6 className="mb-0" style={{fontWeight:'900',fontSize:'20px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(((1 * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100)) + (((1 * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100)) * (6/100)))}</h6>
                            <p className="mb-0" style={{fontSize:'12px'}}>4% withdrawal rate</p>
                        </div>
                    </div>
                    <p className="mb-0" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faChartLine} className="me-1" style={{fontSize: '12px'}} /> Based on 7% annual return</p>
                    <Link to="/performance" className="py-2 rounded-3 mt-1 text-center fe-semibold d-block noLink" style={{border:'2px solid #ff6b35',cursor:'pointer'}}>Explore Scenarios</Link>
                </div>
              </div>
              <div className="col-lg-6 g-4">
                <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faChartLine} className="text-info" style={{fontSize: '20px'}} />
                        <h4 className="mb-0 ms-2" style={{fontWeight:'900'}}>Portfolio Allocation</h4>
                    </div>
                    <p className="mb-0 text-secondary mb-4" style={{fontSize:'14px'}}>Asset Distribution</p>
                    <Pie1 stocks={formatCurrency(enrollment?.stocks)} bonds={formatCurrency(enrollment?.bonds)} cash={formatCurrency(enrollment?.cash)}/>
                    <hr className="my-4" style={{opacity:'0.06'}}/>
                    <div className="d-flex justify-content-around">
                        <div className="text-center">
                            <h3 className="mb-0 text-info" style={{fontWeight:'900'}}>{formatCurrency(enrollment?.stocks)}%</h3>
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Stocks</p>
                        </div>
                        <div className="text-center">
                            <h3 className="mb-0 text-success" style={{fontWeight:'900'}}>{formatCurrency(enrollment?.bonds)}%</h3>
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Bonds</p>
                        </div>
                        <div className="text-center">
                            <h3 className="mb-0 text-primary" style={{fontWeight:'900'}}>{formatCurrency(enrollment?.cash)}%</h3>
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Cash Reserve</p>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-lg-6 g-4">
                <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faReceipt} className="text-primary" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Recent Activity</h5>
                        </div>
                        <Link to="/transaction" className="px-3 py-2 rounded-2 d-flex align-items-center justify-content-center noLink" style={{border:'1px solid #a9a9a90f'}}>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>View All</p>
                        </Link>
                    </div>
                    {allSavings.length > 0 ? (
                      allSavings.slice(0, 10).map((history, index) => (
                      <div key={index} className="mycard mb-2 p-2 rounded-3 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          {history.status === "pending" ? (
                            <FontAwesomeIcon icon={faClock} className="text-warning" style={{ fontSize: "14px" }} />
                          ) : history.type === "dividend" ? (
                            <FontAwesomeIcon icon={faUsd} className="text-info" style={{ fontSize: "14px" }} />
                          ) : history.type === "withdrawal" || history.type === "maintenance" ? (
                            <FontAwesomeIcon icon={faArrowDown} className="text-danger" style={{ fontSize: "14px" }} />
                          ) : (
                            <FontAwesomeIcon icon={faArrowUp} className="text-success" style={{ fontSize: "14px" }} />
                          )}
                          <div className="ms-3">
                              <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{history.type == "dividend" ? 'Dividend' :history.type == "employee match" ? 'Employer Match' :history.type == "withdrawal" ? 'Withdrawals' :history.type == "maintenance" ? 'Maintenance' : 'Contribution'}</p>
                              <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{history.description}</p>
                          </div>
                        </div>
                        <div className="text-end">
                            <p className={`${ history.status == "pending" ? 'text-warning' :history.type == "withdrawal" || history.type == "maintenance" ? 'text-danger' : 'text-success'} mb-0 fw-semibold`} style={{fontSize:'14px'}}>{history.type == "withdrawal" || history.type == "maintenance" ? '-' : '+'}{getCurrencySymbol(user?.currency)}{formatCurrency(history.amountUSD * rate)}</p>
                            <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{history.date}</p>
                        </div>
                      </div>
                      ))
                    ) : (
                      <p className="py-5 text-center mb-0" style={{fontSize:'14px'}}>You have not made any activity yet.</p>
                    )}
                </div>
              </div>
              <div className="col-lg-6 g-4">
                <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                    <h5 className="mb-4" style={{fontWeight:'900'}}>Fund Details</h5>
                    <div className="rounded-3 p-3 mb-3" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faChartLine} style={{fontSize: '16px'}} />
                                <div className="ms-3">
                                    <p className="mb-0 fw-semibold">Large Cap Stock Index</p>
                                    <p className="mb-0" style={{fontSize:'14px'}}>LCSI</p>
                                </div>
                            </div>
                            <div className="text-end">
                                <p className="mb-0" style={{fontWeight:'900'}}>{enrollment.stocks}%</p>
                                <p className="mb-0 rounded-pill bg-prime px-2 py-0 fw-semibold" style={{fontSize:'12px'}}>moderate risk</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Current Value</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(Number(user?.savings) * Number(enrollment.stocks)/100)}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>YTD Return</p>
                                <p className={`mb-0 fw-semibold ${Number(stockDetails.ytdReturn)>0?'text-success':'text-danger'}`} style={{fontSize:'14px'}}><FontAwesomeIcon icon={Number(stockDetails.ytdReturn)>0?faAngleUp:faAngleDown} style={{fontSize: '12px'}} /> {Number(stockDetails.ytdReturn).toFixed(2)}%</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>5-Year Return</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{Number(stockDetails.annualReturnNavY5).toFixed(2)}%</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Expense Ratio</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{Number(stockDetails.netExpenseRatio).toFixed(2)}%</p>
                            </div>
                        </div>
                        <p className="mt-3 mb-0" style={{fontSize:'14px'}}>Tracks the performance of large-cap U.S. stocks</p>
                    </div>
                    <div className="rounded-3 p-3 mb-3" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faBuilding} style={{fontSize: '16px'}} />
                                <div className="ms-3">
                                    <p className="mb-0 fw-semibold">Bond Index Fund</p>
                                    <p className="mb-0" style={{fontSize:'14px'}}>BOND</p>
                                </div>
                            </div>
                            <div className="text-end">
                                <p className="mb-0" style={{fontWeight:'900'}}>{enrollment.bonds}%</p>
                                <p className="mb-0 rounded-pill bg-success px-2 py-0 fw-semibold" style={{fontSize:'12px'}}>low risk</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Current Value</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(Number(user?.savings) * Number(enrollment.bonds)/100)}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>YTD Return</p>
                                <p className={`mb-0 fw-semibold ${Number(bondsDetails.ytdReturn)>0?'text-success':'text-danger'}`} style={{fontSize:'14px'}}><FontAwesomeIcon icon={Number(bondsDetails.ytdReturn)>0?faAngleUp:faAngleDown} style={{fontSize: '12px'}} /> {Number(bondsDetails.ytdReturn).toFixed(2)}%</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>5-Year Return</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{Number(bondsDetails.annualReturnNavY5).toFixed(2)}%</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Expense Ratio</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{Number(bondsDetails.netExpenseRatio).toFixed(2)}%</p>
                            </div>
                        </div>
                        <p className="mt-3 mb-0" style={{fontSize:'14px'}}>Diversified portfolio of U.S. government and corporate bonds</p>
                    </div>
                    <div className="rounded-3 p-3" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faShield} style={{fontSize: '16px'}} />
                                <div className="ms-3">
                                    <p className="mb-0 fw-semibold">Large Cap Stock Index</p>
                                    <p className="mb-0" style={{fontSize:'14px'}}>LCSI</p>
                                </div>
                            </div>
                            <div className="text-end">
                                <p className="mb-0" style={{fontWeight:'900'}}>{enrollment.cash}%</p>
                                <p className="mb-0 rounded-pill bg-success px-2 py-0 fw-semibold" style={{fontSize:'12px'}}>low risk</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Current Value</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(Number(user?.savings) * Number(enrollment.cash)/100)}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>YTD Return</p>
                                <p className={`mb-0 fw-semibold text-success`} style={{fontSize:'14px'}}><FontAwesomeIcon icon={faAngleUp} style={{fontSize: '12px'}} /> 2.4%</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>5-Year Return</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>2.2%</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Expense Ratio</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>2.0%</p>
                            </div>
                        </div>
                        <p className="mt-3 mb-0" style={{fontSize:'14px'}}>Conservative fund with stable returns and capital preservation</p>
                    </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Manager